module.exports = __webpack_public_path__ + "9c744c3e8a2501492ea46693d3c47e67.mtl";